﻿$.fn.dxCtrlFichier2Tag = function custom_dxCtrlFichier2Tag(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2tag dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Tag(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Tag = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivLstFiles = null
    var widthItem = 200
    var jauge = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty()
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({ width: 30, height: 30 }).dxCtrlJauge("instance")
        container.css("text-align", "left")
        $DivLstFiles = $("<div style='font-family:barlow condensed;'/>").appendTo(container)
        resizeObserver.mAdd($DivLstFiles, function () {
            container.find(".itemfile").css("width", mGetWidthTag() + "")
        })
        mRempli()
        container.css("height", "")
    }

    function mRempli() {
        $DivLstFiles.empty()
        option.dataSource.forEach(function (itemData, idx) {
            mAddItem(itemData)
        })
    }
    function mAddItem(itemData) {
        var fichier = new cFichier(option.bddCtrl, itemData.url)
        var $DivFile = $("<div style='cursor:pointer;width:" + mGetWidthTag() + ";margin:2px;padding:2px;display:inline-block;border-radius:5px;border:" + theme.border + ";' title='" + fichier.mGetNom().replace(/'/g, '&#39;') + "' class='itemfile state-hover'></div>").appendTo($DivLstFiles)
        $DivFile.attr("title", fichier.mGetNom())
        $DivFile.on("click", function (e) {
            e.stopPropagation()
            option.onClickFile(itemData)
        })

        var $Table = $("<table style='width:100%;height:100%;height:22px;table-layout: fixed;'/>").appendTo($DivFile)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdFile = $("<td style='width:20px;text-align:center;'/>").appendTo($Tr)
        var fic = new cFichier(option.bddCtrl, itemData.url)
        fic.mGetElementImage(20, 20).appendTo($TdFile)
        var nom = fichier.mGetNom() //.reduit(20)
        var $TdFile = $("<td style='width:calc(100% - 20px);white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis;padding-left:4px;'>" + nom.reduit(14, 5) + "</td>").appendTo($Tr)

        option.bddCtrl.mAjaxCall({
            "command": "gettaillefile",
            url: itemData.url
        }, function (data) {
            $TdFile.html("<span style='opacity:0.5;font-size:80%;'>" + data.taille_octet.sizeFile(1) + "</span><span> &bull; </span><span>" + nom.reduit(14, 5) + "</span>")
            //$TdFile.html("<span style='font-size:70%;'>" + data.taille_octet.sizeFile(1) + "</span><span>&bull;</span>")
            //$("<span>&bull;</span><span style='font-size:70%;'>" + data.taille_octet.sizeFile(1) + "</span>").appendTo($TdFile)
            $DivFile.attr("title", fichier.mGetNom() + "</br>" + data.taille_octet.sizeFile(2))
        })

        if (!option.readOnly && typeof option.onDeleteFiles != "undefined") {
            var $TdFileDel = $("<td style='width:26px;'></td>").appendTo($Tr)
            $("<div style='color:" + theme.backgroundcolorAccent + ";'/>").appendTo($TdFileDel).dxCtrlButtonImage({
                icon: "fas fa-window-close",
                txtTooltip: "Supprimer le fichier joint",
                padding: 2,
                fontSize: 18,
                onClick: function (e) {
                    isDirty = true
                    e.stopPropagation()
                    jauge.mShow()
                    option.onDeleteFiles([itemData], function () {
                        jauge.mHide()
                    })
                    $DivFile.remove()
                }
            })
        }
    }

    function mGetWidthTag() {
        return 220
        var nbItem = parseInt($DivLstFiles.innerWidth() / (widthItem))
        if (nbItem == 1) { return "100%" }
        else {
            var restWidth = $DivLstFiles.innerWidth() - nbItem * (widthItem)
            var restWidthParItem = restWidth / nbItem
            return (widthItem + restWidthParItem - 6) + "px"
        }
    }

    this.mAddNewItemData = function (lstNewItemData) {
        lstNewItemData.forEach(function (itemData) { mAddItem(itemData) })
    }

    this.mRepaint = function () { mConstruit() }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}